type MinicartContainerProps = { children: React.ReactNode };

const MinicartContainer = ({ children }: MinicartContainerProps) => {
	return <div className={`vtex-minicart-2-x-minicartContainer flex flex-column`}>{children}</div>;
};

export default MinicartContainer;
